import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { Slide } from 'react-slideshow-image';
import { productUrl } from 'theme/libs/routes';
import { imageUrl } from 'theme/libs/util';
import './ImageSlider.styles.less';
import { IImageSliderProps } from "./ImageSlider.types";
// refer to https://react-slideshow-image.netlify.app/?path=/docs/introduction--page

export const ImageSlider = ({slidesToScroll, slidesToShow, responsiveSettings, autoplay, indicators, sliderData}:IImageSliderProps) => {
    return (
        <div className='imageSliderContainer section'>
            {sliderData.length > 5 &&
                <Slide slidesToScroll={slidesToScroll} slidesToShow={slidesToShow} indicators={indicators ? indicators : false} responsive={responsiveSettings} autoplay={autoplay ? autoplay : false} 
                    prevArrow= {<LeftOutlined style={{fontSize: '30px', marginLeft: '-20px', color:'black'}}/>} 
                    nextArrow={<RightOutlined  style={{fontSize: '30px', marginRight: '-20px', color: 'black'}}/>}
                >
                    {sliderData.map((product:any, i:number) => {
                        console.log(product)
                        return <div key={i} className="eachSlider">
                            <Link to={productUrl(product.relatedId.toString())}>
                                <img className="lazy" 
                                    src={imageUrl(product, { x: 330, y: 330, t: "image/png", b:"#f2f1f6" })}
                                    title={product.relatedName}
                                />
                                <br />
                                <div className='imgTitle'>{product.relatedName}</div> 
                                <div className='subTitle'>{product.retailPriceLowDisplay}</div>
                            </Link>
                        </div>
                    }
                    )}               
                </Slide>
            }
            {sliderData.length <= 5  && // this condition is required, otherwise the slider will not show it right
                sliderData.map((product:any, i:number) => {
                        console.log(product)
                        return <div key={i} className="grid-list-item">
                            <Link to={productUrl(product.relatedId.toString())}>
                                <img className="lazy" 
                                    src={imageUrl(product, { x: 330, y: 330, t: "image/png", b:"#f2f1f6" })}
                                    title={product.relatedName}
                                />
                                <br />
                                <div className='imgTitle'>{product.relatedName}</div> 
                                <div className='subTitle'>{product.retailPriceLowDisplay}</div>
                            </Link>
                        </div>
                    }
                )  
            }
            
        </div>
    );
}